import React, { useEffect } from 'react'
import LiveChat from 'react-livechat'
import { withSupportChat, withProfile } from 'redux/enhancers'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'

const LIVECHAT_LICENSE_ID = 11715957
let LIVECHAT_API = null

// eslint-disable-next-line no-unused-vars
const SupportChat = ({
  supportChatIsVisible,
  showSupportChat,
  hideSupportChat,
  user: { login, email, firstname, lastname },
  setSupportChatIsReady
}) => {
  useEffect(() => {
    if (LIVECHAT_API && LIVECHAT_API.is_loaded()) {
      if (supportChatIsVisible) {
        LIVECHAT_API.open_chat_window()
      } else {
        LIVECHAT_API.hide_chat_window()
      }
    }
  }, [supportChatIsVisible])

  return (
    <LiveChat
      license={LIVECHAT_LICENSE_ID}
      onMessage={showSupportChat}
      visitor={{ name: `${firstname} ${lastname}`, email }}
      // eslint-disable-next-line no-return-assign
      onChatLoaded={ref => {
        LIVECHAT_API = ref
        LIVECHAT_API.on_after_load = () => {
          LIVECHAT_API.set_custom_variables([{ name: 'login', value: login }])
          setSupportChatIsReady()
        }
      }}
      onChatWindowMinimized={hideSupportChat}
      onChatWindowHidden={hideSupportChat}
    />
  )
}

export default errorBoundaryEnhancer(withSupportChat(withProfile(SupportChat)))
